import React from 'react';
import { ListItemText, Menu, MenuItem, PopoverOrigin } from '@mui/material';
import { isMobile } from 'utils/device';

interface OutputFormatMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onSelect: (format: string) => void;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  onMouseEnter?: React.MouseEventHandler<HTMLElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLElement>;
  menuPaperRef?: React.Ref<HTMLDivElement>;
}

const OutputFormatMenu: React.FC<OutputFormatMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onSelect,
  anchorOrigin = {
    vertical: 'top',
    horizontal: 'left',
  },
  transformOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  },
  onMouseEnter,
  onMouseLeave,
  menuPaperRef,
}) => {
  const formatOptions = [
    { value: 'list', label: 'List' },
    { value: 'table', label: 'Table' },
    { value: 'memo', label: 'Memo' },
    { value: 'briefing', label: 'Briefing' },
    { value: 'freeform', label: 'Free Form' },
    { value: 'chronology', label: 'Chronology' },
  ];

  const handleMenuItemClick = (format: string) => {
    onSelect(format);
    onClose();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disableRestoreFocus
      sx={{
        pointerEvents: 'none',
        maxWidth: isMobile ? '90vw' : '200px',
        '& .MuiPaper-root': {
          marginTop: '-8px', // Small offset to appear just above the chip
          pointerEvents: 'auto',
        },
      }}
      slotProps={{
        paper: {
          onMouseEnter,
          onMouseLeave,
          style: {
            maxHeight: '70vh', // Limit height to prevent cutoff
          },
          sx: {
            minWidth: 180,
            fontSize: '1rem',
            boxShadow: '0 16px 44px rgba(15, 23, 42, 0.14)',
            border: '1px solid #e5e7eb',
            borderRadius: '4px',
            padding: '8px',
          },
          ref: menuPaperRef,
        },
      }}
      MenuListProps={{
        dense: true,
      }}
    >
      {formatOptions.map((option) => (
        <MenuItem
          key={option.value}
          onClick={() => handleMenuItemClick(option.value)}
          sx={{
            minWidth: '110px',
            fontSize: '1rem',
          }}
        >
          <ListItemText primary={option.label} primaryTypographyProps={{ fontSize: '1rem' }} />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default OutputFormatMenu;
